

import React from "react";
import Header from "../components/web-component/Header";
// import Footer from "../components/Footer";

const MainLayout = ({ children }) => {
  return (
    <div className="app-container">

      <Header />

      
      <main className="main-content">
        {children}
      </main>

      
      {/* <Footer /> */}

    </div>
  );
};

export default MainLayout;